import { TokenEngine } from "@vp/vp-js-token-engine";
const tokenEngine = new TokenEngine();
const MAX_OPTIONS = 3;
export function buildUnwindingMessageHtml(i18n, templateBase, violations, optionCausingUnselect) {
    const unwindingOptionCount = violations.length;
    const unwindingTemplateSuffix = unwindingOptionCount > Math.min(MAX_OPTIONS, violations.length)
        ? "more"
        : unwindingOptionCount.toString();
    const unwindingTemplateId = `${templateBase}_${unwindingTemplateSuffix}`;
    const unwindingOptionTokens = {
        ATTRIBUTE_COUNT: MAX_OPTIONS.toString(),
    };
    if (optionCausingUnselect) {
        (unwindingOptionTokens.ATTRIBUTE = getStyledText(optionCausingUnselect.attributeName, "normal")),
            (unwindingOptionTokens.OPTION = getStyledText(optionCausingUnselect.optionName, "bold"));
    }
    violations.forEach((v, index) => {
        const optionToken = `ATTRIBUTE${index + 1}`;
        const valueToken = `OPTION${index + 1}`;
        unwindingOptionTokens[optionToken] = getStyledText(v.attributeName, "normal");
        unwindingOptionTokens[valueToken] = getStyledText(v.optionName, "bold");
    });
    // This cast is necessary since we're building up the name of the template programmatically.
    // Likewise, the ?? coalesce below should remain
    const unwindingTemplate = i18n(unwindingTemplateId);
    return tokenEngine.replace(unwindingTemplate ?? "", unwindingOptionTokens);
}
function getStyledText(text, style = "normal") {
    switch (style) {
        case "bold":
            return `<span class="swan-font-weight-bold">${text}</span>`;
        case "normal":
            return `<span class="swan-font-weight-normal">${text}</span>`;
        case "none":
            return `${text}`;
    }
}
//# sourceMappingURL=buildUnwindingMessageHtml.js.map